var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_169",
    "data-name": "Group 169",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.5,
    height: 71.582,
    viewBox: "0 0 73.5 71.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 73.5,
    height: 71.582,
    fill: "#2c3584",
    stroke: "#2c3584",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M28.922,71.582A28.9,28.9,0,0,0,50.2,23.1l5.444-5.445a1.2,1.2,0,0,0,.852.506l11.393,1.252a1.1,1.1,0,0,0,.134.007A1.214,1.214,0,0,0,68.157,17L57.472,15.825l3.133-3.131a1.334,1.334,0,0,0,.154.033l11.393,1.252c.045,0,.089.007.134.007a1.214,1.214,0,0,0,.13-2.42L62.79,10.509,68.637,4.66a1.213,1.213,0,0,0-1.715-1.715l-6,6L57.761.777a1.213,1.213,0,1,0-2.262.874l3.511,9.062a.885.885,0,0,0,.052.091l-2.582,2.582L53.307,4.943a1.213,1.213,0,0,0-2.272.852l3.509,9.345c.017.045.047.076.065.117l-6.125,6.125a28.915,28.915,0,1,0-19.562,50.2m0-55.417A26.39,26.39,0,0,1,46.769,23.1l-5.725,5.725a18.442,18.442,0,1,0,1.717,1.717l5.723-5.726a26.482,26.482,0,1,1-19.562-8.647m-.858,27.352a1.208,1.208,0,0,0,1.715,0l3.738-3.736A5.451,5.451,0,1,1,31.8,38.066L28.065,41.8a1.212,1.212,0,0,0,0,1.715m5.479-7.194a7.877,7.877,0,1,0,1.717,1.715l5.78-5.782a16.035,16.035,0,1,1-1.715-1.713Z",
    transform: "translate(0 0)",
    fill: "#2c3584",
    stroke: "#2c3584",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPic1);
export default __webpack_public_path__ + "static/media/hero_pic1.e8fdbd41c7b5a07f65b55ea2597c2ba9.svg";
export { ForwardRef as ReactComponent };